import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { GoogleApiWrapper } from 'google-maps-react';

export class MapContainer extends Component {
  state = {
    zoom: 14, // 地图缩放
    position: { 'lat': 40.748610, 'lng': -73.938890 },
    myCenter: { 'lat': 40.748610, 'lng': -73.938890 }, // 中心点
  };
  
  componentDidMount () {
    this.initMap()
  }

  initMap = () => {
    if (this.props && this.props.google) { 
      const { myCenter, zoom, position } = this.state;
      const { google } = this.props;
      const maps = google.maps;

      const { lat, lng } = myCenter;
      const center = new maps.LatLng(lat, lng);

      const myOptions = {
        zoom, // 缩放级数
        center, // 位置
        mapTypeId: maps.MapTypeId.ROADMAP, // 地图的初始类型
        mapTypeControl: false, //切换地图类型控件
        zoomControl: false, // 缩放控件
        scaleControl: true, // 提供简单地图比例的比例控件
        streetViewControl: false, // 街景小人控件
      };
      const mapRef = this.refs.map;
      const node = ReactDOM.findDOMNode(mapRef);
      
      const map = new maps.Map(node, myOptions);
  
      // 创建Marker
      const marker = new maps.Marker({
        position,
        map: map
      });
  
      // 创建InfoWindow
      const htmlWindow = `<div>
          <h4><b>Airacer Inc.</b></h4>
          <p>Corporate Office</p>
        </div>`;
  
      const infowindow= new maps.InfoWindow({
        content: htmlWindow,
        disableAutoPan:true // 设置为true时可禁用自动平移功能
      });
  
      //打开信息窗体
      infowindow.open(maps, marker);
      
      marker.addListener('click', () => {
        infowindow.open(maps, marker);
      });
    }
  }

  render() {
    return (
      <div className="map-box" ref="map">
      </div>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyAtMvOFQlg7_XA4-OuVcjqXBUys7kdhyPs',
})(MapContainer);
